import {
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { InputComponent } from "@components/input/input.component";
import { Subject, takeUntil } from "rxjs";
import { DisabledControlDirective } from "~app/common/directives/disabled-control/disabled-control.directive";
import { FormBinderService } from "~app/common/services/form-binder.service";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import { IValidationScope } from "~app/common/validation/IValidationScope";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ILagerplats, IMottagningsplats } from "../../mottagningsplats.models";
import { MottagningsplatsDetaljerTexts } from "../mottagningsplats-detaljer.texts";
import { MottagningsplatsDetaljerPlatsValidation } from "../mottagningsplats-detaljer.validation";

@Component({
    selector: "rask-mottagningsplats-detaljer-plats",
    templateUrl: "./mottagningsplats-detaljer-plats.component.html",
    styleUrls: ["./mottagningsplats-detaljer-plats.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        InputComponent,
        InputNumberComponent,
        CheckboxComponent,
        DisabledControlDirective
    ]
})
export class MottagningsplatsDetaljerPlatsComponent implements OnInit, OnDestroy, OnChanges {
    form: UntypedFormGroup;
    initialized = false;
    @Input() lagerplats: ILagerplats;
    @Input() mottagningsplats: IMottagningsplats;
    @Input() rootForm: UntypedFormGroup;
    texts = MottagningsplatsDetaljerTexts.texts;
    validation: IValidationScope;
    validationContext: IValidationContext;

    private readonly formBinder = inject(FormBinderService);
    private readonly ngFormSubscription$ = new Subject<void>();

    get isReadOnly(): boolean {
        return (this.lagerplats.avlamningsplats === "0" && !this.validationContext.hasErrors(ValidationScopes.spara)) || this.lagerplats.finnsIViol3;
    }

    ngOnChanges() {
        this.setUpForm();
    }

    ngOnDestroy(): void {
        this.formBinder.detachFromRootForm(this.rootForm, `platsut${this.lagerplats.id}`);
        this.ngFormSubscription$?.next();
        this.ngFormSubscription$?.complete();
    }

    ngOnInit() {
        this.setUpForm();
        this.initialized = true;
    }

    setUpForm(): void {
        this.ngFormSubscription$?.next();

        this.form = this.formBinder.CreateGroup(this.lagerplats);

        this.validationContext = MottagningsplatsDetaljerPlatsValidation.initPlats(this.mottagningsplats, this.lagerplats);
        this.validationContext.scope(ValidationScopes.spara)
            .pipe(takeUntil(this.ngFormSubscription$))
            .subscribe(v => {
                this.validation = v;
            });

        this.validationContext.validate();
        this.formBinder.attachToRootForm(this.rootForm, this.form, `platsut${this.lagerplats.id}`).subscribe(x => {
            this.formBinder.attachValidation(this.validationContext.current, this.form, true);
            this.initialized = true;
        });

        this.rootForm.valueChanges
            .pipe(takeUntil(this.ngFormSubscription$))
            .subscribe(() => {
                this.validationContext.validate();
                this.form.updateValueAndValidity({
                    onlySelf: true,
                    emitEvent: false
                });
            });
    }
}
